/**
 * 排行榜首页 顶部头部
 *
 * @format
 */

import React from 'react';
import PropTypes from 'prop-types';
//@ts-ignore
import { observer } from 'mobx-react';
//@ts-ignore
import { StyleSheet, View, Animated, Platform } from 'react-native';
//@ts-ignore
import {
  JDShare,
  JDDevice,
  JDNativeSystem,
  JDTouchable,
  JDText,
  JDImage,
  JDNativeToast,
} from '@jdreact/jdreact-core-lib';

// import frameDataStore from '../store/frameData';
// import rankCateMap from '../store/rankCateMap';
import navigationBarVisibilityStore from '../services/navigationBarVisibility/store';
import goodsContrastPageStore from '../services/goodsContrastPageStore/store';
import Images from '../images';
import NavigationBar from './JDReactNavigationBar';
import Steep from '../utils/Steep';
import { logClick, ContrastShare, ContrastCateEntry } from '../mta/MtaService';
import { thistle } from '../../../scripts/common/colors-cli/lib/color-name';
const { getRpx, getFontsize } = JDDevice;
const styles = StyleSheet.create({
  titleMain: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
  titleImage: {
    width: Math.min(JDDevice.getRpx(178), 121),
    height: Math.min(JDDevice.getRpx(50), 34),
  },
  categoryImage: {
    width: Math.min(JDDevice.getRpx(44), 32),
    height: Math.min(JDDevice.getRpx(46), 32),
  },
  lbsinfoContainer: {
    position: 'absolute',
    top: JDDevice.getRpx(0),
    height: 44,
    justifyContent: 'center',
  },
  lbsinfo: {
    color: '#999',
    fontSize: JDDevice.getRpx(22),
  },
  navigationBarContainer: {
    position: 'absolute',
    width: JDDevice.getRpx(750),
    marginTop: JDNativeSystem.isIPhoneX ? JDDevice.getRpx(20) : 0,
    left: 0,
    zIndex: 100,
  },
  placeholder: {
    backgroundColor: '#FFFFFF',
  },
  navigationBtn: {
    height: 44,
    width: JDDevice.getRpx(80),
    justifyContent: 'center',
    alignItems: 'center',
  },
  navigationBtnLeft: {
    marginLeft: JDDevice.getRpx(10),
  },
  navigationBtnRight: {
    marginRight: JDDevice.getRpx(10),
  },
  backIcon: {
    width: JDDevice.getRpx(40),
    height: JDDevice.getRpx(40),
  },
  shareIcon: {
    width: JDDevice.getRpx(34),
    height: JDDevice.getRpx(34),
  },

  switchCategory: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'flex-start',
    paddingLeft: getRpx(27),
    paddingRight: getRpx(27),
    backgroundColor: 'rgba(242,242,242,1)',
  },
  showSwitchCategory: {
    // height: '100%',
    borderTopLeftRadius: getRpx(30),
    borderTopRightRadius: getRpx(30),
  },
  hideSwitchCategory: {
    // height: getRpx(60),
    borderRadius: getRpx(30),
  },
  arrowUp: {
    width: getRpx(20),
    height: getRpx(20),
    marginLeft: getRpx(12),
  },
  switchCategoryPress: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titltText: {
    fontSize: getRpx(26),
  },
});
interface INavigstionStore {
  navigationBarVisibility: {
    showing: boolean;
  };
  goodsContrastPageStore: {
    shareVo: null | {
      //主标题
      masterText: string;
      //副标题
      viceText: string;
      //对比详情 >",
      bottomText: string;
      //分享icon
      iconUrl: string;
    };
    golbalSku: string;
    cateId: string;
    entrySku: string;
    currCategory: string;
    showCateList: boolean;
    titleHeight: any;
    arrowDirection: any;
    isReadOnly: boolean;
  };
}
interface IProps {
  isReadOnly?: boolean;
  isNormal: boolean;
  disableShare?: boolean;
  title: string;
}
type INavigationProps = IProps & INavigstionStore;
interface INavigationState {
  top: number;
}
class TopNavigationBar extends React.Component<INavigationProps, INavigationState> {
  static propTypes = {
    navigationBarVisibility: (PropTypes as any).shape({
      showing: (PropTypes as any).bool,
    }).isRequired,
    isNormal: (PropTypes as any).bool,
    disableShare: (PropTypes as any).bool,
  };
  showing: boolean;
  static defaultProps = {
    isNormal: true,
    disableShare: false,
  };

  static contextTypes = {
    router: (PropTypes as any).object,
  };

  constructor(props: INavigationProps) {
    super(props);

    this.state = {
      top: new Animated.Value(
        props.navigationBarVisibility && props.navigationBarVisibility.showing
          ? 0
          : -Steep.NAVIGATION_BAR_HEIGHT - (Platform.OS === 'ios' ? 60 : 0)
      ),
    };
    this.showing = props.navigationBarVisibility.showing;
    this.goBack = this.goBack.bind(this);
    this.openShareDialog = this.openShareDialog.bind(this);
    this.renderLeftButton = this.renderLeftButton.bind(this);
    this.renderRightButton = this.renderRightButton.bind(this);
  }

  goBack() {
    this.context.router.goBack();
  }

  renderLeftButton() {
    return (
      <JDTouchable onPress={this.goBack} key={'leftButton'} style={[styles.navigationBtn, styles.navigationBtnLeft]}>
        <JDImage source={Images.common.back} style={styles.backIcon} />
      </JDTouchable>
    );
  }
  renderRightButton() {
    return (
      <>
        {!this.props.disableShare ? (
          <JDTouchable
            onPress={this.openShareDialog}
            key={'rightButton'}
            style={[styles.navigationBtn, styles.navigationBtnRight]}
          >
            <JDImage source={Images.common.share} style={styles.shareIcon} />
          </JDTouchable>
        ) : null}
      </>
    );
  }
  openShareDialog() {
    const {
      goodsContrastPageStore: { entrySku, golbalSku, cateId, shareVo },
    } = this.props;
    if (!shareVo) {
      return;
    }
    if (golbalSku === '') {
      JDNativeToast.show('请至少添加1个商品哦～', JDNativeToast.SHORT, JDNativeToast.FAIL);
      return;
    }
    const share = {
      //正式
      shareUrl: `https://clutter.m.jd.com/retail/m/contrast/contrast/index.html?skuId=${golbalSku}&cateId=${cateId}&action=4&client=h5/`,
      //预发
      // shareUrl: `http://clutter.m.jd.care/retail/m/contrast/contrast/index.html?skuId=${golbalSku}&cateId=${cateId}&action=4&client=h5/`,
      masterText: shareVo.masterText,
      viceText: shareVo.viceText,
      bottomText: shareVo.bottomText,
      iconUrl: shareVo.iconUrl
        ? shareVo.iconUrl
        : 'https://m.360buyimg.com/cc/jfs/t1/121031/24/5228/16446/5eeb25c1Efb07b0d6/218074d7190986fa.png',
    };

    logClick({
      event_id: ContrastShare,
      event_param: '',
      page_param: entrySku,
    });
    JDShare.showShareDialog(
      share.shareUrl,
      share.masterText,
      share.viceText + '\n\n' + share.bottomText,
      share.iconUrl,
      'eventName'
    );
  }
  slideDownSelectCategory = () => {
    const {
      goodsContrastPageStore: { entrySku, isReadOnly },
    } = this.props;
    if (isReadOnly) return;
    //点击类目埋点
    logClick({
      event_id: ContrastCateEntry,
      event_param: '',
      page_param: entrySku,
    });
    // this.arrowDown();
    goodsContrastPageStore.slideDownSelectCategory();
  };
  render() {
    const {
      navigationBarVisibility,
      isNormal,
      goodsContrastPageStore: { currCategory, showCateList, titleHeight, arrowDirection, isReadOnly },
    } = this.props;

    let switchCategoryStyle = showCateList
      ? [styles.switchCategory, styles.showSwitchCategory]
      : [styles.switchCategory, styles.hideSwitchCategory];
    const renderTitle = () => (
      <View style={styles.titleMain}>
        {isNormal ? (
          <View>
            <JDText>{this.props.title ? this.props.title : '商品对比页'}</JDText>
          </View>
        ) : (
          <JDTouchable onPress={this.slideDownSelectCategory}>
            <Animated.View
              style={[
                switchCategoryStyle,
                {
                  height: titleHeight.interpolate({
                    inputRange: [0, 1],
                    outputRange: [getRpx(60), getRpx(100)],
                  }),
                },
              ]}
            >
              <View style={styles.switchCategoryPress}>
                <JDText style={styles.titltText}>{currCategory == '' ? '商品对比' : `${currCategory}对比`}</JDText>
                {!isReadOnly ? (
                  <View>
                    <Animated.Image
                      source={Images.common.SelectCategoryArrowUp}
                      style={[
                        styles.arrowUp,
                        {
                          transform: [
                            {
                              rotateX: arrowDirection.interpolate({
                                inputRange: [0, 1],
                                outputRange: ['180deg', '0deg'],
                              }),
                            },
                          ],
                        },
                      ]}
                    ></Animated.Image>
                  </View>
                ) : null}
              </View>
            </Animated.View>
          </JDTouchable>
        )}
      </View>
    );

    if (this.showing !== navigationBarVisibility.showing) {
      if (navigationBarVisibility.showing) {
        Animated.timing(this.state.top, {
          toValue: 0,
          duration: 120,
          useNativeDriver: true,
        }).start();
      } else {
        Animated.timing(this.state.top, {
          toValue: -Steep.NAVIGATION_BAR_HEIGHT - (Platform.OS === 'ios' ? 60 : 0) - Steep._getSteepBarHeight(),
          duration: 120,
          useNativeDriver: true,
        }).start();
      }
    }

    this.showing = navigationBarVisibility.showing;
    //头部高度=导航栏固定高度+榜单描述块高度+沉浸式头部顶部占位块高度
    const tmpHeight = Steep.NAVIGATION_BAR_HEIGHT + Steep._getSteepBarHeight();
    return (
      <Animated.View
        style={[
          styles.navigationBarContainer,
          { height: tmpHeight },
          {
            transform: [
              {
                translateY: this.state.top,
              },
            ],
          },
        ]}
      >
        <NavigationBar
          LeftButton={this.renderLeftButton}
          RightButton={this.renderRightButton}
          Title={renderTitle}
          showMoreNav={false}
        />
      </Animated.View>
    );
  }
}

const TopNavigationBarPlaceholderBase = ({ navigationBarVisibility }: INavigationProps) => {
  const iOSPadding = JDNativeSystem.isIPhoneX ? 54 : 20;
  let placeHolderHeight;
  if (navigationBarVisibility.showing) {
    placeHolderHeight = 44 + (Platform.OS === 'ios' ? iOSPadding : 0) + Steep._getContainerChangeHeight();
  } else {
    placeHolderHeight = 10 + (Platform.OS === 'ios' ? iOSPadding : 0) + Steep._getContainerChangeHeight();
  }
  return <View style={[styles.placeholder, { height: placeHolderHeight }]} />;
};

TopNavigationBarPlaceholderBase.propTypes = {
  navigationBarVisibility: (PropTypes as any).shape({
    showing: (PropTypes as any).bool,
  }).isRequired,
};

const TopNavigationBarOberver = observer(TopNavigationBar);

const TopNavigationBarOberverWrapper = (props: INavigationProps) => (
  <TopNavigationBarOberver
    {...props}
    // frameData={frameDataStore}
    navigationBarVisibility={navigationBarVisibilityStore}
    goodsContrastPageStore={goodsContrastPageStore}
  />
);

const TopNavigationBarPlaceholderBaseOberver = observer(TopNavigationBarPlaceholderBase);

const TopNavigationBarPlaceholder = () => (
  <TopNavigationBarPlaceholderBaseOberver navigationBarVisibility={navigationBarVisibilityStore} />
);

export default TopNavigationBarOberverWrapper;
export { TopNavigationBarPlaceholder };
